import axios from "axios";

const RAW_BASE_URL =
  process.env.REACT_APP_API_BASE ||
  "https://backre-miami.us-3.evennode.com";

const BASE_URL = String(RAW_BASE_URL).replace(/\/+$/, "");

const apiLogin = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
});

export const postLogin = async (payload) => {
  try {
    const { data } = await apiLogin.post("/login", payload, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (data?.token) {
      localStorage.setItem("token", data.token);
    }

    const usuario = data?.usuario || data?.user || null;

    if (usuario) {
      localStorage.setItem("usuario", JSON.stringify(usuario));
      localStorage.setItem("user", JSON.stringify(usuario));
      localStorage.setItem(
        "id",
        String(usuario._id || usuario.id || "")
      );
    }

    const display = String(
      [usuario?.nombres, usuario?.apellidos]
        .filter(Boolean)
        .join(" ") ||
        usuario?.username ||
        usuario?.usuario ||
        usuario?.name ||
        ""
    ).trim();

    if (display) {
      localStorage.setItem("userDisplay", display);
    }

    // Compatible con LoginForm, que espera respuesta.data.ok
    return {
      ...data,
      data,
      loading: false,
    };
  } catch (error) {
    const data =
      error.response?.data || {
        ok: false,
        err: {
          message:
            error.message ||
            "No se pudo conectar con el servidor",
        },
      };

    return {
      ...data,
      data,
      loading: false,
    };
  }
};